import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISiparisDetay_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISiparisDetay_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  GoBack: any;
  GoBack_dummy: any;
  GetSiparisTra: any[];
  GetSiparisTra_dummy: any[];
  HesaplaSiparisDetay: any[];
  HesaplaSiparisDetay_dummy: any[];
  isComp630030Visible: "visible" | "hidden";
  isComp805344Visible: "visible" | "hidden";
  isComp23982Visible: "visible" | "hidden";
  isComp90473Visible: "visible" | "hidden";
  isComp494833Visible: "visible" | "hidden";
  isComp83157Visible: "visible" | "hidden";
  isComp740578Visible: "visible" | "hidden";
}

export class SiparisDetay_ScreenBase extends React.PureComponent<
  ISiparisDetay_ScreenProps,
  any
> {
  siparisdetay_527622_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 976235,
          PropertyName: "value",
          Value: "B2B ORDER DETAILS",
          TagName: "Label17_0_value",
        },
        {
          Id: 731035,
          PropertyName: "value",
          Value: "ORDER CART DETAILS",
          TagName: "Label25_value",
        },
        {
          Id: 538542,
          PropertyName: "value",
          Value: "PAYMENT INFORMATION",
          TagName: "Label29_value",
        },
        {
          Id: 872436,
          PropertyName: "value",
          Value: "ORDER NOTE",
          TagName: "Label26_value",
        },
        {
          Id: 731885,
          PropertyName: "value",
          Value: "PAYMENT TYPE",
          TagName: "Label28_value",
        },
        {
          Id: 957686,
          PropertyName: "value",
          Value: "TOTAL AMOUNT",
          TagName: "Label29_value",
        },
        {
          Id: 629912,
          PropertyName: "value",
          Value: "OVERALL DISCOUNT 1",
          TagName: "Label36_value",
        },
        {
          Id: 726070,
          PropertyName: "value",
          Value: "OVERALL DISCOUNT 2",
          TagName: "Label33_value",
        },
        {
          Id: 746809,
          PropertyName: "value",
          Value: "OVERALL DISCOUNT 3",
          TagName: "Label30_value",
        },
        {
          Id: 387257,
          PropertyName: "value",
          Value: "NET AMOUND",
          TagName: "Label29_value",
        },
        {
          Id: 976917,
          PropertyName: "value",
          Value: "TAX",
          TagName: "Label29_value",
        },
        {
          Id: 154200,
          PropertyName: "value",
          Value: "OVERALL TOTAL",
          TagName: "Label29_value",
        },
        {
          Id: 423146,
          PropertyName: "value",
          Value: "B2B ORDER NO / ERP ORDER NO",
          TagName: "Label1_value",
        },
        {
          Id: 742470,
          PropertyName: "value",
          Value: "REQUEST NUMBER",
          TagName: "Label3_value",
        },
        {
          Id: 534672,
          PropertyName: "value",
          Value: "CUSTOMER ID",
          TagName: "Label4_value",
        },
        {
          Id: 748437,
          PropertyName: "value",
          Value: "DATE",
          TagName: "Label6_value",
        },
        {
          Id: 506333,
          PropertyName: "value",
          Value: "SITUATION",
          TagName: "Label6_value",
        },
        {
          Id: 854430,
          PropertyName: "value",
          Value: "SENDER",
          TagName: "Label6_value",
        },
        {
          Id: 630030,
          PropertyName: "value",
          Value: "CONFIRMED",
          TagName: "Label43_value",
        },
        {
          Id: 805344,
          PropertyName: "value",
          Value: "PENDING",
          TagName: "Label44_value",
        },
        {
          Id: 23982,
          PropertyName: "value",
          Value: "DECLINED",
          TagName: "Label45_value",
        },
        {
          Id: 83707,
          PropertyName: "title",
          Value: "PICTURE",
          TagName: "TableTemplateColumn1_0_title",
        },
        {
          Id: 469457,
          PropertyName: "title",
          Value: "STOCK CODE",
          TagName: "TableTemplateColumn10_title",
        },
        {
          Id: 978338,
          PropertyName: "title",
          Value: "STOCK NAME",
          TagName: "TableTemplateColumn2_title",
        },
        {
          Id: 3470,
          PropertyName: "title",
          Value: "BRAND",
          TagName: "TableTemplateColumn3_title",
        },
        {
          Id: 397575,
          PropertyName: "title",
          Value: "AMOUNT",
          TagName: "TableTemplateColumn4_title",
        },
        {
          Id: 106931,
          PropertyName: "title",
          Value: "UNIT PRICE",
          TagName: "TableTemplateColumn7_title",
        },
        {
          Id: 980996,
          PropertyName: "title",
          Value: "NET PRICE",
          TagName: "TableTemplateColumn9_title",
        },
        {
          Id: 361038,
          PropertyName: "title",
          Value: "NET AMOUND",
          TagName: "TableTemplateColumn8_title",
        },
      ],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [
        {
          Id: 976235,
          PropertyName: "value",
          Value: "Detalles del pedido B2B",
          TagName: "Label17_0_value",
        },
        {
          Id: 731035,
          PropertyName: "value",
          Value: "Información del carrito",
          TagName: "Label25_value",
        },
        {
          Id: 538542,
          PropertyName: "value",
          Value: "Información del pago",
          TagName: "Label29_value",
        },
        {
          Id: 872436,
          PropertyName: "value",
          Value: "Notas del pedido",
          TagName: "Label26_value",
        },
        {
          Id: 731885,
          PropertyName: "value",
          Value: "Tipo de pago",
          TagName: "Label28_value",
        },
        {
          Id: 957686,
          PropertyName: "value",
          Value: "Valor total",
          TagName: "Label29_value",
        },
        {
          Id: 629912,
          PropertyName: "value",
          Value: "Descuento general 1",
          TagName: "Label36_value",
        },
        {
          Id: 726070,
          PropertyName: "value",
          Value: "Descuento general 2",
          TagName: "Label33_value",
        },
        {
          Id: 746809,
          PropertyName: "value",
          Value: "Descuento general 3",
          TagName: "Label30_value",
        },
        {
          Id: 387257,
          PropertyName: "value",
          Value: "Valor neto",
          TagName: "Label29_value",
        },
        {
          Id: 976917,
          PropertyName: "value",
          Value: "IVA",
          TagName: "Label29_value",
        },
        {
          Id: 154200,
          PropertyName: "value",
          Value: "Total",
          TagName: "Label29_value",
        },
        {
          Id: 423146,
          PropertyName: "value",
          Value: "No. de pedido B2B / No. de pedido ERP",
          TagName: "Label1_value",
        },
        {
          Id: 742470,
          PropertyName: "value",
          Value: "Número de solicitud",
          TagName: "Label3_value",
        },
        {
          Id: 534672,
          PropertyName: "value",
          Value: "Código actual",
          TagName: "Label4_value",
        },
        {
          Id: 748437,
          PropertyName: "value",
          Value: "Fecha",
          TagName: "Label6_value",
        },
        {
          Id: 506333,
          PropertyName: "value",
          Value: "Estado",
          TagName: "Label6_value",
        },
        {
          Id: 854430,
          PropertyName: "value",
          Value: "Remitente",
          TagName: "Label6_value",
        },
        {
          Id: 630030,
          PropertyName: "value",
          Value: "Aprobado",
          TagName: "Label43_value",
        },
        {
          Id: 805344,
          PropertyName: "value",
          Value: "Pendiente",
          TagName: "Label44_value",
        },
        {
          Id: 23982,
          PropertyName: "value",
          Value: "Rechazado",
          TagName: "Label45_value",
        },
        {
          Id: 83707,
          PropertyName: "title",
          Value: "Imagen",
          TagName: "TableTemplateColumn1_0_title",
        },
        {
          Id: 469457,
          PropertyName: "title",
          Value: "Código de stock",
          TagName: "TableTemplateColumn10_title",
        },
        {
          Id: 978338,
          PropertyName: "title",
          Value: "Nombre del stock",
          TagName: "TableTemplateColumn2_title",
        },
        {
          Id: 3470,
          PropertyName: "title",
          Value: "Marca",
          TagName: "TableTemplateColumn3_title",
        },
        {
          Id: 397575,
          PropertyName: "title",
          Value: "Cantidad",
          TagName: "TableTemplateColumn4_title",
        },
        {
          Id: 106931,
          PropertyName: "title",
          Value: "Precio unitario",
          TagName: "TableTemplateColumn7_title",
        },
        {
          Id: 980996,
          PropertyName: "title",
          Value: "Precio neto",
          TagName: "TableTemplateColumn9_title",
        },
        {
          Id: 361038,
          PropertyName: "title",
          Value: "Valor neto",
          TagName: "TableTemplateColumn8_title",
        },
      ],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [
        {
          Id: 976235,
          PropertyName: "value",
          Value: "Détails de la commande B2B",
          TagName: "Label17_0_value",
        },
        {
          Id: 731035,
          PropertyName: "value",
          Value: "Informations sur le panier",
          TagName: "Label25_value",
        },
        {
          Id: 538542,
          PropertyName: "value",
          Value: "Informations de paiement",
          TagName: "Label29_value",
        },
        {
          Id: 872436,
          PropertyName: "value",
          Value: "Remarque sur la commande",
          TagName: "Label26_value",
        },
        {
          Id: 731885,
          PropertyName: "value",
          Value: "Type de paiement",
          TagName: "Label28_value",
        },
        {
          Id: 957686,
          PropertyName: "value",
          Value: "Montant total",
          TagName: "Label29_value",
        },
        {
          Id: 629912,
          PropertyName: "value",
          Value: "Remise générale 1",
          TagName: "Label36_value",
        },
        {
          Id: 726070,
          PropertyName: "value",
          Value: "Remise générale 2",
          TagName: "Label33_value",
        },
        {
          Id: 746809,
          PropertyName: "value",
          Value: "Remise générale 3",
          TagName: "Label30_value",
        },
        {
          Id: 387257,
          PropertyName: "value",
          Value: "Montant net",
          TagName: "Label29_value",
        },
        {
          Id: 976917,
          PropertyName: "value",
          Value: "TVA",
          TagName: "Label29_value",
        },
        {
          Id: 154200,
          PropertyName: "value",
          Value: "Total général",
          TagName: "Label29_value",
        },
        {
          Id: 423146,
          PropertyName: "value",
          Value: "Numéro de commande B2B / Numéro de commande ERP",
          TagName: "Label1_value",
        },
        {
          Id: 742470,
          PropertyName: "value",
          Value: "Numéro de demande",
          TagName: "Label3_value",
        },
        {
          Id: 534672,
          PropertyName: "value",
          Value: "Code courant",
          TagName: "Label4_value",
        },
        {
          Id: 748437,
          PropertyName: "value",
          Value: "Date",
          TagName: "Label6_value",
        },
        {
          Id: 506333,
          PropertyName: "value",
          Value: "Statut",
          TagName: "Label6_value",
        },
        {
          Id: 854430,
          PropertyName: "value",
          Value: "Expéditeur",
          TagName: "Label6_value",
        },
        {
          Id: 630030,
          PropertyName: "value",
          Value: "Approuvé",
          TagName: "Label43_value",
        },
        {
          Id: 805344,
          PropertyName: "value",
          Value: "En attente",
          TagName: "Label44_value",
        },
        {
          Id: 23982,
          PropertyName: "value",
          Value: "Refusé",
          TagName: "Label45_value",
        },
        {
          Id: 83707,
          PropertyName: "title",
          Value: "Image",
          TagName: "TableTemplateColumn1_0_title",
        },
        {
          Id: 469457,
          PropertyName: "title",
          Value: "Code stock",
          TagName: "TableTemplateColumn10_title",
        },
        {
          Id: 978338,
          PropertyName: "title",
          Value: "Nom du stock",
          TagName: "TableTemplateColumn2_title",
        },
        {
          Id: 3470,
          PropertyName: "title",
          Value: "Marque",
          TagName: "TableTemplateColumn3_title",
        },
        {
          Id: 397575,
          PropertyName: "title",
          Value: "Quantité",
          TagName: "TableTemplateColumn4_title",
        },
        {
          Id: 106931,
          PropertyName: "title",
          Value: "Prix unitaire",
          TagName: "TableTemplateColumn7_title",
        },
        {
          Id: 980996,
          PropertyName: "title",
          Value: "Prix net",
          TagName: "TableTemplateColumn9_title",
        },
        {
          Id: 361038,
          PropertyName: "title",
          Value: "Montant net",
          TagName: "TableTemplateColumn8_title",
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "fddf851f-b71f-4e5d-bfe3-334a8cb92739",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 976235, PropertyName: "value", Value: "B2B Sipariş Detayları" },
        {
          Id: 423146,
          PropertyName: "value",
          Value: "B2B Sipariş No / ERP Sipariş No",
        },
        { Id: 739413, PropertyName: "value", Value: "/" },
        { Id: 742470, PropertyName: "value", Value: "Talep Numarası" },
        { Id: 534672, PropertyName: "value", Value: "Cari Kod" },
        { Id: 748437, PropertyName: "value", Value: "Tarih" },
        { Id: 506333, PropertyName: "value", Value: "Durum" },
        { Id: 630030, PropertyName: "value", Value: "Onaylandı" },
        { Id: 805344, PropertyName: "value", Value: "Bekliyor" },
        { Id: 23982, PropertyName: "value", Value: "Reddedildi" },
        { Id: 854430, PropertyName: "value", Value: "Gönderen" },
        { Id: 83707, PropertyName: "title", Value: "Resim" },
        { Id: 469457, PropertyName: "title", Value: "Stok Kodu" },
        { Id: 118021, PropertyName: "value", Value: "[datafield:stokkodu]" },
        { Id: 978338, PropertyName: "title", Value: "Stok Adı" },
        { Id: 71886, PropertyName: "value", Value: "[datafield:stokadi]" },
        { Id: 3470, PropertyName: "title", Value: "Marka" },
        { Id: 8575, PropertyName: "value", Value: "[datafield:musterimarka]" },
        { Id: 397575, PropertyName: "title", Value: "Miktar" },
        { Id: 822622, PropertyName: "value", Value: "[datafield:miktar]" },
        { Id: 106931, PropertyName: "title", Value: "Birim Fiyat" },
        { Id: 828780, PropertyName: "value", Value: "[datafield:birimfiyat]" },
        { Id: 980996, PropertyName: "title", Value: "Net Fiyat" },
        { Id: 769290, PropertyName: "value", Value: "[datafield:netfiyat]" },
        { Id: 361038, PropertyName: "title", Value: "Net Tutar" },
        { Id: 381902, PropertyName: "value", Value: "[datafield:nettutar]" },
        { Id: 499227, PropertyName: "title", Value: "Kalem Not" },
        { Id: 202444, PropertyName: "value", Value: "[datafield:kalemnot]" },
        { Id: 731035, PropertyName: "value", Value: "Sepet Bilgileri" },
        { Id: 872436, PropertyName: "value", Value: "Sipariş Notu" },
        { Id: 731885, PropertyName: "value", Value: "Ödeme Tipi" },
        { Id: 538542, PropertyName: "value", Value: "Ödeme Bilgileri" },
        { Id: 957686, PropertyName: "value", Value: "Toplam Tutar" },
        { Id: 629912, PropertyName: "value", Value: "Genel İskonto 1" },
        { Id: 726070, PropertyName: "value", Value: "Genel İskonto 2" },
        { Id: 746809, PropertyName: "value", Value: "Genel İskonto 3" },
        { Id: 387257, PropertyName: "value", Value: "Net Tutar" },
        { Id: 976917, PropertyName: "value", Value: "Kdv" },
        { Id: 154200, PropertyName: "value", Value: "Genel Toplam" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.siparisdetay_527622_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      GoBack: "",
      GetSiparisTra: [],
      HesaplaSiparisDetay: [],
      isComp630030Visible: "hidden",
      isComp805344Visible: "hidden",
      isComp23982Visible: "hidden",
      isComp90473Visible: "hidden",
      isComp494833Visible: "hidden",
      isComp83157Visible: "hidden",
      isComp740578Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("siparisdetay", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.SiparisDetayPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("siparisdetay", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("siparisdetay", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.SiparisDetayPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  SiparisDetayPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      cariKod_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKodu ?? this.props.screenInputs.carikodu,
        "string"
      ),
      Sipno_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.SiparisNumarasi ??
          this.props.screenInputs.siparisnumarasi,
        "string"
      ),
      SiparisNumarasi_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.SiparisNumarasi ??
          this.props.screenInputs.siparisnumarasi,
        "string"
      ),
      CariKod_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CariKodu ?? this.props.screenInputs.carikodu,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SiparisDetay/SiparisDetayPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetSiparisTra = result?.data.getSiparisTra;

    stateVars.HesaplaSiparisDetay = result?.data.hesaplaSiparisDetay;
    formVars.siparisdetay_800616_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].toplamTutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].toplamTutar
        : null
    );
    formVars.siparisdetay_710212_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelIsk1Tutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelIsk1Tutar
        : null
    );
    formVars.siparisdetay_445222_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelIsk2Tutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelIsk2Tutar
        : null
    );
    formVars.siparisdetay_132535_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelIsk3Tutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelIsk3Tutar
        : null
    );
    formVars.siparisdetay_848695_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].netTutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].netTutar
        : null
    );
    formVars.siparisdetay_224277_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].kdvTutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].kdvTutar
        : null
    );
    formVars.siparisdetay_656059_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelToplam
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelToplam
        : null
    );
    stateVars.isComp90473Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaSiparisDetay !== undefined
            ? stateVars.HesaplaSiparisDetay?.length > 0
              ? stateVars.HesaplaSiparisDetay[0].genelIsk1Tutar
              : null
            : this.state.HesaplaSiparisDetay?.length > 0
            ? this.state.HesaplaSiparisDetay[0].genelIsk1Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp494833Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaSiparisDetay !== undefined
            ? stateVars.HesaplaSiparisDetay?.length > 0
              ? stateVars.HesaplaSiparisDetay[0].genelIsk2Tutar
              : null
            : this.state.HesaplaSiparisDetay?.length > 0
            ? this.state.HesaplaSiparisDetay[0].genelIsk2Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp83157Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaSiparisDetay !== undefined
            ? stateVars.HesaplaSiparisDetay?.length > 0
              ? stateVars.HesaplaSiparisDetay[0].genelIsk3Tutar
              : null
            : this.state.HesaplaSiparisDetay?.length > 0
            ? this.state.HesaplaSiparisDetay[0].genelIsk3Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp740578Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaSiparisDetay !== undefined
            ? stateVars.HesaplaSiparisDetay?.length > 0
              ? stateVars.HesaplaSiparisDetay[0].kdvTutar
              : null
            : this.state.HesaplaSiparisDetay?.length > 0
            ? this.state.HesaplaSiparisDetay[0].kdvTutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SiparisDetayPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SiparisDetayPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp630030Visible =
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.SiparisDurumu ??
          this.props.screenInputs.siparisdurumu,
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp805344Visible =
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.SiparisDurumu ??
          this.props.screenInputs.siparisdurumu,
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp23982Visible =
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.SiparisDurumu ??
          this.props.screenInputs.siparisdurumu,
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_527622 =
      stateVars.GetSiparisTra ?? this.state.GetSiparisTra;

    formVars.siparisdetay_800616_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].toplamTutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].toplamTutar
        : null
    );

    stateVars.isComp90473Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaSiparisDetay !== undefined
            ? stateVars.HesaplaSiparisDetay?.length > 0
              ? stateVars.HesaplaSiparisDetay[0].genelIsk1Tutar
              : null
            : this.state.HesaplaSiparisDetay?.length > 0
            ? this.state.HesaplaSiparisDetay[0].genelIsk1Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.siparisdetay_710212_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelIsk1Tutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelIsk1Tutar
        : null
    );

    stateVars.isComp494833Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaSiparisDetay !== undefined
            ? stateVars.HesaplaSiparisDetay?.length > 0
              ? stateVars.HesaplaSiparisDetay[0].genelIsk2Tutar
              : null
            : this.state.HesaplaSiparisDetay?.length > 0
            ? this.state.HesaplaSiparisDetay[0].genelIsk2Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.siparisdetay_445222_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelIsk2Tutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelIsk2Tutar
        : null
    );

    stateVars.isComp83157Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaSiparisDetay !== undefined
            ? stateVars.HesaplaSiparisDetay?.length > 0
              ? stateVars.HesaplaSiparisDetay[0].genelIsk3Tutar
              : null
            : this.state.HesaplaSiparisDetay?.length > 0
            ? this.state.HesaplaSiparisDetay[0].genelIsk3Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.siparisdetay_132535_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelIsk3Tutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelIsk3Tutar
        : null
    );

    formVars.siparisdetay_848695_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].netTutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].netTutar
        : null
    );

    stateVars.isComp740578Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaSiparisDetay !== undefined
            ? stateVars.HesaplaSiparisDetay?.length > 0
              ? stateVars.HesaplaSiparisDetay[0].kdvTutar
              : null
            : this.state.HesaplaSiparisDetay?.length > 0
            ? this.state.HesaplaSiparisDetay[0].kdvTutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.siparisdetay_224277_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].kdvTutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].kdvTutar
        : null
    );

    formVars.siparisdetay_656059_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelToplam
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelToplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  SiparisDetayComponent_16802_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "SiparisDetay",
      "AnaSayfa",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisDetayComponent_834971_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisDetayComponent_186103_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "Resimler",
      "StokKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "siparisdetay_527622_value",
          "stokKodu"
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "SiparisDetay",
      "Resimler",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "883817",
      null,
      null,
      "true",
      "600px",
      "600px",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SiparisDetayComponent_202444_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, 883817] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.SiparisDetayPageInit();
    }
  }
}
